import dataBloedNietErnstigTAR from "../../../../src/data/niet-ernstige-bloedingen-onder-tar.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataBloedNietErnstigTAR,
  BasicCollapse,
  React
};